import React, { useState, useEffect } from "react";
import "./TableList.css";

const RowList = (props) => {

  const [checked, setCheck] = useState(false);
  const keys = Object.keys(props.data);
  const [operations, setOperations] = useState(null);

  useEffect(()=>{

    if(props.dataFull.length > 0){
      let infos = props.dataFull.filter((e)=> e.code == props.data["Código"])
      infos = infos[0]
      if(typeof infos.operations != "undefined"){
        console.log(infos.operations)
        let op = <table className="nested-table">
          <thead>
          <tr>
            <th>Código</th>
            <th>Alternativa</th>
            <th>PPH</th>
            <th>PPC</th>
            <th>Tempo de espera</th>
            <th>Máquina</th>
          </tr>
          </thead>
          <tbody>
          {infos.operations.map((e)=>(
            <tr>
            <td>{e.code}</td>
            <td>{e.alternative}</td>
            <td>{e.pph}</td>
            <td>{e.piece_cicle}</td>
            <td>{e.time_wait_piece_cicle}</td>
            <td>{`${e.description_machine}${e.code_machine}`}</td>
          </tr>
          )
          )}
          </tbody>
        </table>;
        setOperations(op);
      }
    }

  },[props.dataFull])


  return (
    <>
    <tr key={props.data.id}>
      {props.machineTrackList
        ? keys.map((key, index) =>
            index === 0 ? (
              <td key={key}>{props.data[key]}</td>
            ) : (
              <td>
                <input />
              </td>
            )
          )
        : keys.map((key) => <td key={key}>{props.data[key]}</td>)}
    
    </tr>
    {operations !== null ? (<tr className="operationsTable">
      <td colSpan={keys.length}>
        <details>
          <summary>Ver operações</summary>
          {operations}
        </details>
      </td>
    </tr>) : (<></>)}
    
    
    </>
  );
};

const TableList = ({ data, machineTrackList, dataFull }) => {
  const [keys, setKeys] = useState([]);
  const [completeData, setCompleteData] = useState([]);

  useEffect(() => {
    if (data.length > 0) {
      setKeys(Object.keys(data[0]));
    }
  }, [data]);

  useEffect(()=>{

    if(dataFull.length > 0){
      setCompleteData(dataFull);
    }else{

    }

  },[dataFull])

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            {keys.map((item) => (
              <th
                style={{ position: 'sticky', top: 0, background: 'white' }}
                key={item}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((rowData, index) => (
            <RowList
              data={rowData}
              key={index}
              dataFull ={completeData}
              machineTrackList={machineTrackList}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableList;